import { render, staticRenderFns } from "./ControlLink.vue?vue&type=template&id=0bd656aa&"
import script from "./ControlLink.vue?vue&type=script&lang=js&"
export * from "./ControlLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports